import { sendToApi } from 'api/client'

type CreateIntegrationParams = {
  oauth_token: string
  oauth_verifier: string
  oauth_token_secret: string
}

type CreatePostParams = {
  text: string
  mediaFileIds?: number[]
}

export const XClient = {
  createIntegration: async ({ workspaceId, params }: { workspaceId: number; params: CreateIntegrationParams }) => {
    const res = await sendToApi<void>(`/w/${workspaceId}/x/integration`, {
      body: params,
      method: 'POST',
    })

    if (res.type === 'error') {
      throw new Error(res.statusText || 'API Error')
    }

    return res
  },
  requestToken: async ({ workspaceId }: { workspaceId: number }) => {
    const res = await sendToApi<{ token: string; token_secret: string }>(`/w/${workspaceId}/x/integration/token`)

    if (res.type === 'error') {
      throw new Error(res.statusText || 'API Error')
    }

    return res
  },
  createPost: async ({
    workspaceId,
    text,
    mediaFileIds,
    sourceId,
    sourceType,
    externalIntegrationId,
  }: {
    workspaceId: number
    sourceId: string
    sourceType: string
    externalIntegrationId: number
  } & CreatePostParams) => {
    const res = await sendToApi(`/w/${workspaceId}/x/posts`, {
      method: 'POST',
      body: {
        text,
        media_file_ids: mediaFileIds,
        source_id: sourceId,
        source_type: sourceType,
        external_integration_id: externalIntegrationId,
      },
    })

    if (res.type === 'error') {
      if (res.status === 400) {
        throw new Error(`From X: ${res.data.error}`)
      }
      throw new Error(res.statusText || 'API Error')
    }

    return res
  },
}
